export default "__VITE_ASSET__Bp$IJaqE__"